<template>
  <img :src="getImageUrl('/images/shop.svg')">
</template>
<script>
import profileMixin from "../../mixins/profileMixin";

export default {
  mixins: [profileMixin]
}
</script>


// WEBPACK FOOTER //
// src/components/SVG/CartSvg.vue